import React from 'react';
import { useFormContext } from 'react-hook-form';
import 'react-phone-number-input/style.css';
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form';
import { getCountryCallingCode, isPossiblePhoneNumber } from 'react-phone-number-input';
import ValidationErrorMessage from './ValidationErrorMessage';
import PropTypes from 'prop-types';

/**
 * Component that returns the contact number select list and input.
 *
 * @params See propTypes.
 * @returns {JSX.Element}
 * @component
 */
const ContactNumber = ({ formConfig, addressCountry }) => {
  /**
   * Deconstructs react hook form methods from parent form.
   */
  const {
    control,
    formState: { errors }
  } = useFormContext();

  /**
   * Get the default calling code country based on the addressCountry
   * @returns {null|*}
   */
  const getDefaultCountry = () => {
    try {
      // This function throws an error if the country calling code does not exist.
      getCountryCallingCode(addressCountry.alpha2);

      return addressCountry.alpha2;
    } catch (error) {
      return null;
    }
  };

  return (
    <div className="d-flex flex-column">
      <label
        className="mt-8 fw-normal"
        htmlFor="HPP_CUSTOMER_PHONENUMBER_MOBILE">
        Contact number {formConfig.Fields.HPP_CUSTOMER_PHONENUMBER_MOBILE.IsRequired ? '' : '(optional)'}
      </label>

      {
        errors.HPP_CUSTOMER_PHONENUMBER_MOBILE &&
        <ValidationErrorMessage 
          error={errors.HPP_CUSTOMER_PHONENUMBER_MOBILE}
          input="HPP_CUSTOMER_PHONENUMBER_MOBILE"
        />
      }

      <PhoneInputWithCountry
        name="HPP_CUSTOMER_PHONENUMBER_MOBILE"
        id="HPP_CUSTOMER_PHONENUMBER_MOBILE"
        control={control}
        defaultCountry={getDefaultCountry()}
        international
        countryCallingCodeEditable={false}
        rules={{
          required: {
            value: formConfig.Fields.HPP_CUSTOMER_PHONENUMBER_MOBILE.IsRequired,
            message: formConfig.Fields.HPP_CUSTOMER_PHONENUMBER_MOBILE.ValidationMsg
          },
          validate: {
            is_possible_phone_number: (value) => {
              if (!formConfig.Fields.HPP_CUSTOMER_PHONENUMBER_MOBILE.IsRequired) {
                return false;
              }
              if (!isPossiblePhoneNumber(value)) {
                return formConfig.Fields.HPP_CUSTOMER_PHONENUMBER_MOBILE.ValidationMsg;
              }
            }
          }
        }}/>

    </div>

  );
};
ContactNumber.propTypes = {
  /**
   * The form settings returned from the settings api.
   */
  formConfig: PropTypes.object.isRequired,
  /**
   * The address country value
   */
  addressCountry: PropTypes.object.isRequired
};

export default ContactNumber;
